<template>
    <div class="container">
        <b-form class="mt-4 mb-4">

            <template v-if="trelloReady">
                <!-- cards cardsType="owner" v-on:change-selected="onChangeSelectedCard"></cards> -->
                <cards cardsType="all" v-on:change-selected="onChangeSelectedCard"></cards>
                <search-card v-on:change-selected="onChangeSelectedCard"></search-card>
                <AddCardByUrl v-on:change-selected="onChangeSelectedCard"></AddCardByUrl>
                <ValidateAssociation v-bind:card="selectedCard"></ValidateAssociation>
            </template>
            <div v-else>
                <b-alert show variant="primary">En attente de connexion avec Trello - <a href="#" v-on:click="trelloAuthorize">cliquez ici</a> </b-alert>
            </div>

        </b-form>
    </div>
</template>

<script>

  import Cards from './AssociateSub/Cards'
  import SearchCard from './AssociateSub/SearchCard'
  import ValidateAssociation from './AssociateSub/ValidateAssociation'
  import AddCardByUrl from './AssociateSub/AddCardByUrl'

  export default {

    name: 'Associate',

    data() {
      return {
        trelloReady: false,
        selectedCard: {
          id: '',
          name: 'en attente de sélection',
          desc: 'test'
        }
      }
    },

    mounted() {
      this.trelloAuthorize()
    },

    components: {
      Cards,
      SearchCard,
      ValidateAssociation,
      AddCardByUrl
    },

    methods: {

      trelloAuthorize: function () {

        window.Trello.authorize({
          type: 'popup',
          name: 'Vostok Subjects Manager',
          scope: {
            read: 'true',
            write: 'true'
          },
          expiration: 'never',
          success: this.authenticationSuccess,
          error: this.authenticationFailure
        })
      },

      authenticationSuccess: function () {
        this.trelloReady = true
        console.log('Successful Trello authentication')
      },

      authenticationFailure: function () {
        this.trelloReady = false
        console.log('Failed Trello authentication')
      },

      onChangeSelectedCard: function (card) {
        this.selectedCard = card
        console.log('carte sélectionnée -> id: ' + this.selectedCard.id + ' nom: ' + this.selectedCard.name)
        console.log(this.selectedCard.desc)
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/Associate.vue